/**
 * Utility functions for browser detection
 */

/**
 * Detects if the user is on iOS (any browser)
 * @returns boolean indicating if user is on iOS
 */
export const isiOS = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * Detects if the user is on Chrome browser
 * @returns boolean indicating if user is on Chrome
 */
export const isChrome = (): boolean => {
  return (
    navigator.userAgent.includes("Chrome") &&
    !navigator.userAgent.includes("Edg")
  );
};
